export default __webpack_public_path__ + "static/media/maypay_probability.678df4b3.svg";